module.exports = __webpack_public_path__ + "img/24.118a04a2.jpg";